import {isMobile} from '../helpers';

function updateElementsPosition(slick, nextSlide) {
  if (isMobile()) {
    const blockSelector = '.legacy__block';
    const textHeight = $(slick.$slides[nextSlide]).find('p').outerHeight(true);
    const defaultPadding = 180;
    const defaultMargin = 70;
    const parentBlock = $(slick.$slider).closest(blockSelector);
    const moreBlock = parentBlock.find('.legacy__block-more-wrapper');
    let resultMargin = -10;
    let resultPadding = defaultPadding + textHeight;

    if (textHeight > 0) {
      resultMargin = textHeight - defaultMargin;
    }

    if (moreBlock.length === 0) {
      resultPadding = defaultPadding - 50;
    }

    moreBlock.css('margin-top', `${resultMargin}px`);
    parentBlock.next(blockSelector).css('padding-top', `${resultPadding}px`);
  }
}

const bigSliderHandler = () => {
  const Slider = document.getElementsByClassName('big-slider');

  if (!Slider.length) return;

  $(Slider).on('init', (_, slick) => {
    updateElementsPosition(slick, 0);
  });

  $(Slider).slick({
    centerMode: true,
    centerPadding: '212px',
    slidesToShow: 1,
    prevArrow:
      "<button class='slick-arrow slick-prev'><div class='big-slider__arrow big-slider__arrow--prev'><svg><use xlink:href='/static/core/img/sprites.svg#arrow-left-round'></use></svg><div class='big-slider__arrow-content'></div></div></button>",
    nextArrow:
      "<button class='slick-arrow slick-next'><div class='big-slider__arrow big-slider__arrow--next'><svg><use xlink:href='/static/core/img/sprites.svg#arrow-left-round'></use></svg><div class='big-slider__arrow-content'></div></div></button>",

    responsive: [
      {
        breakpoint: 1281,
        settings: {
          centerPadding: '26px',
          arrows: false
        }
      }
    ]
  });

  $(Slider).on('beforeChange', (_, slick, currentSlide, nextSlide) => {
    if (nextSlide === 0 && currentSlide === slick.slideCount - 1) {
      $(slick.$slider).find('.slick-active').next('.slick-cloned').addClass('slick-updated');
    }

    updateElementsPosition(slick, nextSlide);
  });

  $(Slider).on('afterChange', (_, slick) => {
    $(slick.$slider).find('.slick-updated').removeClass('slick-updated');
  });
};

const BigSliderComponent = () => {
  bigSliderHandler();
};

export const BigSlider = () => {
  $(document).ready(() => BigSliderComponent());
};
